<section id="testimonials" class="testimonials">
  <div class="container">
<header class="section-header">
      <h2>Our Parents' Views</h2>
    </header>

    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div id="testimonialCarousel" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="3" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="4" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="5" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="6" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="7" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="8" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="9" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="10" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="11" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="12" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="13" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="14" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="15" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="16" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="17" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="18" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="19" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="20" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="21" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="22" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="23" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="24" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="25" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="26" aria-label="Slide 3"></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Harjot  ( Pre-Nursery)</h4>
                <p> The school is very nice .
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Avira ( Nursery )</h4>
                <p> We are totally satisfied with the teaching. The Class teacher is very friendly and our kid is performing well.
                </p>
              </div>
             
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Shaksham ( Nursery)</h4>
                <p> The class teacher is very good. 
                </p>
              </div>
            </div>

            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Hiral ( Nursery) </h4>
                <p> The class teacher is very cooperative . School Management is very good.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>parent of Yashaswni ( Nursery)</h4>
                <p>Class teacher's interaction level is excellent with students. 
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Pari ( Nursery)</h4>
                <p> The school is very good.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Divansh ( Nursery)</h4>
                <p> The school is very good .
                </p>
              </div>
            </div>
            
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Mehreen ( Nursery)</h4>
                <p> The class teacher is very good. Her teaching method is good.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Arjun ( Nursery) </h4>
                <p> The Class teacher is very cooperative and labourious.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Mohan ( Nursery)</h4>
                <p> Excellent mode of teaching, great atmosphere for studies, excellent teaching skill of the teacher.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Harrin Kush ( Nursery )</h4>
                <p> Class taecher's online teaching method is so good, She always encourages our child to study and adopt good habbits.
                </p>
              </div>
            </div>

            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Bhuvan ( Nursery)</h4>
                <p> Class teacher is very good and nice. The school is very good.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Rehnoor ( Nursery)</h4>
                <p> The class teacher is really doing a good job.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parents of Kavish ( Nursery)</h4>
                <p> The teacher's teaching method is very impressive. Everythng is understandable.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>26-04-2021</h2>
                <h4>Parent of Vannniya (LKG) </h4>
                <p> All parents are very happy with online evening classes.
                </p>
              </div>
            </div>

            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>22-04-2021</h2>
                <h4>Parent of Tanishka (UKG)</h4>
                <p> We are very happy with online evening classes , We appreciate this effort made by the school for the working parents .
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>22-04-2021</h2>
                <h4> Parent of Kamaljot (Grade VI)</h4>
                <p>All is great here, syllabus is very good.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>17-08-2021</h2>
                <h4>Parent of Divyam ( Pre-Nursery) </h4>
                <p> Divyam is very fond of his class-teacher, the teachng method adopted by class incharge is easy and comprehensible.
                I wish all the very best to the school and thank them for inventing new ways of engaging kids for there holistic development. 
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>17-08-2021</h2>
                <h4> Parent of Aditya (Pre-Nursery)</h4>
                <p> Everything is great here. I am fully satisfied with the school and the teachers.
                </p>
              </div>
            </div>

            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>16-08-2021</h2>
                <h4> Parent of Charvi ( Pre-nursery)</h4>
                <p> Classes are conducted very nicely here, Charvi has gained interest in studies only because of interactive session conducted by the class-teacher.<br>
                I would like to thank the teacher for her patience and  cooperation.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>16-08-2021</h2>
                  <h4>Parent of Arav ( Pre- Nursery)</h4>
                  <p> The class teacher is teaching in a superb way. She is very calm, polite and patient. She knows how to handle the students in a proper way . 
                  Students also obey her. 
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Aadrika ( Pre-Nursery)</h4>
                <p> Online classes are being taken in a good manner and wards are enjoying it. 
                They are taking keen interest in the classes due to the effort of their teachers.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Amoha Goyal ( Pre-Nursery)</h4>
                <p> I am very happy to send my ward here. Amoha is making effort to do well.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Viraaj ( Pre- Nursery)</h4>
                <p>The teachers here are very cooperative. We are very satisfied.
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Saera ( Pre- Nursery)</h4>
                <p> Everything is good here. Teachers are maintaining proper discipline amongst students which is appreciable. We are satisfied. 
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4> Parent of Gargi ( Pre-Nursery)</h4>
                <p> Good efforts are being made by school. 
                </p>
              </div>
            </div>
            <div class="carousel-item">
              <div class="testimonial-item">
                <img src="/assets/img/testimonial/1.jpeg" class="testimonial-img" alt="Tagore Global School Kurukshetra">
                <h2>07-08-2021</h2>
                <h4>Parent of Rehana Narwal ( Pre-Nursery) </h4>
                <p> Teachers are making good efforts to improve children. Everything is good here.
                </p>
              </div>
            </div>
            



          </div>
        </div>
        

      </div>
    </div>

  </div>
</section>